import QUERY_KEYS from 'network/config/queryKeys';
import React from 'react';
import { useInfiniteQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { getVendorsByCategory } from '../../network/services/goods';

export default function useVendorsByCategoriesHook() {
  const [searchParams] = useSearchParams();
  const LIMIT = 10;

  const category = searchParams.get('category');

  const {
    isFetching: categoryVendorsFetching,
    data: categoryVendorsData,
    hasNextPage: categoryVendorsHasNext,
    fetchNextPage: categoryVendorsFetchNext,
    error: categoryVendorsError
  } = useInfiniteQuery({
    queryKey: [QUERY_KEYS.VENDORS_BY_CATEGORIES, { categoryId: category }],
    enabled: category != null ? !!category : true,
    queryFn: ({ pageParam = 0 }) => getVendorsByCategory({ categoryId: category, page: pageParam, size: LIMIT }),
    getNextPageParam: (lastPage, allPages) => ((lastPage ?? []).length === LIMIT ? allPages.length : undefined),

    // Cache configuration to prevent frequent refreshing
    staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh for 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes - data stays in cache for 10 minutes
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data exists
    refetchOnReconnect: false, // Don't refetch when network reconnects

    // Optional: Only refetch if data is older than staleTime
    refetchInterval: false // Disable automatic refetching
  });

  const fetchMoreCategoryVendors = React.useCallback(() => {
    if (categoryVendorsHasNext) {
      categoryVendorsFetchNext();
    }
  }, [categoryVendorsFetchNext, categoryVendorsHasNext]);

  return {
    categoryVendorsData,
    categoryVendorsFetching,
    fetchMoreCategoryVendors,
    categoryVendorsError
  };
}
